import React, { useEffect, useState, useRef } from 'react'
import {
  Card,
  message,
  Button,
  Col,
  ConfigProvider,
  Row,
  Table,
  Collapse,
  Tabs,
} from 'antd'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism'
import commitDetailStyle from './commit-detail-oam.module.less'
import { sendHttpPostRequest } from '@/api/http-request'
import * as constants from '../../../../constants/constants'
import  marked  from 'marked'
import ReactMarkdown from 'react-markdown'
import rehypeKatex from 'rehype-katex'
import 'katex/dist/katex.min.css' // `rehype-katex` does not import the CSS for you
import gfm from 'remark-gfm'
import remarkMath from 'remark-math'
import rehypeRaw from 'rehype-raw'
import rehypeHighlight from 'rehype-highlight'
import taskLearnStyles from '@/pages/task/task-learn.module.less'
import zhCN from 'antd/es/locale/zh_CN'
import {
  DownOutlined,
  UpOutlined,
} from '@ant-design/icons'
export interface Props {
  mode: string
  setSelectedTabKey?: any
  projectId?: any
  submitId?: any
}

const { Panel } = Collapse
const { TabPane } = Tabs

const CommitDetail: React.FC<Props> = (props) => {
  const { mode, setSelectedTabKey, projectId, submitId } = props
  const [userInfo, setUserInfo] = useState<any>()
  const [taskInfo, setTaskInfo] = useState<any>()
  const [variables, setVariables] = useState(null as any) //运行的输出变量列表
  const [outputs, setOutputs] = useState<any>()
  const [isAnimation, setIsAnimation] = useState(false)
  const [userImage, setUserImage] = useState(null as any) //
  const [submitImages, setSubmitImages] = useState([]) //运行结果图

  const [verticalPane1Height, setVerticalPane1Height] = useState(
    document.body.clientHeight / 2
  ) //

  const specialTreatment = useRef(false)
  const animationTimer = useRef<any>()

  const [codeLanguage] = useState('python')

  const [runningStatus, setRunningStatus] = useState(0)

  const [valueContentOpen, setValueContentOpen] = useState(true)

  const openValueContent = () => {
    {
      valueContentOpen ? setValueContentOpen(false) : setValueContentOpen(true)
    }
  }

  const renderValue = (value: any, record: any) => {
    console.log(record.var)
    if (value.length > 35) {
      return (
        <div key={record.var}>
          <div
            style={{
              color: '#374151',
              marginLeft: 20,
              marginRight: 20,
              marginBottom: 10,
              paddingTop: 0,
              borderRadius: 5,
            }}
          >
            {valueContentOpen
              ? value.slice(0, 35).replaceAll('\n', '<br/>')
              : value.replaceAll('\n', '<br/>')}
          </div>
        </div>
      )
    } else
      return (
        <div key={record.var}>
          <div
            style={{
              color: '#374151',
              marginLeft: 20,
              marginRight: 20,
              marginBottom: 10,
              paddingTop: 0,
              borderRadius: 5,
            }}
          >
            {value.replaceAll('\n', '<br/>')}
          </div>
        </div>
      )
  }

  const variableColumns: any = [
    {
      title: '变量',
      dataIndex: 'var',
      key: 'var',
      align: 'left',
      width: 60,
    },
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type',
      ellipsis: true,
      align: 'left',
      width: 60,
    },

    {
      title: (
        <div>
          取值{' '}
          <Button
            onClick={openValueContent}
            className={taskLearnStyles.openBtn}
            style={{ float: 'right', marginLeft: 5, color: '#a5b4fc' }}
          >
            {valueContentOpen ? (
              <span>
                展开
                <DownOutlined style={{ marginLeft: 5 }} />
              </span>
            ) : (
              <span>
                收起
                <UpOutlined style={{ marginLeft: 5 }} />
              </span>
            )}
          </Button>
        </div>
      ),
      dataIndex: 'value',
      key: 'value',
      align: 'left',
      width: 100,
      render: renderValue,
    },
  ]


  const goBack = () => {
    if (mode == 'teacher') {
      setSelectedTabKey('my_commit_record')
    }
  }
  const specialTreatmentfun = (responseOutPut) => {
    let tb_startInd = responseOutPut.indexOf('+--')
    let tb_endInd = responseOutPut.lastIndexOf('--+') + 3
    let pre_str = responseOutPut.substr(0, tb_startInd)
    let nex_str = responseOutPut.substr(tb_endInd)

    let prepare_marked = responseOutPut.slice(tb_startInd, tb_endInd)

    let tbarr = prepare_marked.split('|')
    tbarr.shift()
    tbarr.pop()
    let tbstr = tbarr.join('|')
    for (let i = 0; i < tbstr.length; i++) {
      if (
        (tbstr[i] === '+' && tbstr[i + 1] === '-' && tbstr[i + 2] === '-') ||
        (tbstr[i] === '+' && tbstr[i - 1] === '-' && tbstr[i - 2] === '-')
      ) {
        tbstr = tbstr.replace(tbstr[i], '|')
      }
    }
    let marktable = marked.parse(tbstr)
    setOutputs(pre_str + marktable + nex_str)
  }

  // 请求提交记录详情

  const getCommitDetail = () => {
    let data = {
      exercise_submit_id: submitId,
    }
    sendHttpPostRequest('exercise/api/exercise_run_detail', data, (res) => {
      if (res.code == 0) {
        let taskInfo = res.data.exercise_info.task_detail
        setUserInfo(res.data.user_info)
        setTaskInfo(res.data.exercise_info)
        setRunningStatus(res.data.exercise_info.submit_status)
        setVariables(taskInfo.variables)
        setOutputs(taskInfo.output)
        setIsAnimation(taskInfo.is_animation)
        
        if (taskInfo.image.length > 0) {
          setSubmitImages(taskInfo.image)
        }
        if (taskInfo.is_animation) {
          clearInterval(animationTimer.current)
          let imgs = taskInfo.image
          let n = 0
          animationTimer.current = setInterval(function () {
            // console.log('转视频', n)

            let imgContain: any =
              document.getElementById('animation_img') &&
              document.getElementById('animation_img')
            if (imgContain) {
              imgContain.src = 'data:image/jpg;base64,' + imgs[n]
              n = n + 1
              if (n >= imgs.length) {
                n = 0
              }
            }
          }, 100)
        }
        if (taskInfo.is_html) {
          setUserImage(taskInfo.output)
         
          setOutputs('')
          eval(taskInfo.js_script)
        }
        // 判断output 是否为表格
        else if (
          taskInfo.output &&
          taskInfo.output != '' &&
          taskInfo.output.indexOf('+--') >= 0 &&
          taskInfo.output.lastIndexOf('--+') >= 0
        ) {
          specialTreatment.current = true
          try {
            specialTreatmentfun(taskInfo.output)
          } catch (e) {
            console.error(e)
          }
        } else {
          specialTreatment.current = false
          setUserImage('')
          
          setOutputs(taskInfo.output)
        }
      } else {
        message.error(res.msg)
      }
    })
  }

  useEffect(() => {
    getCommitDetail()
  }, [])

  return (
    <div
      className={
        mode == 'teacher'
          ? commitDetailStyle.containTeacher
          : commitDetailStyle.contain
      }
    >
      <Card
        title="提交记录详情"
        bordered={false}
        style={
          mode == 'oam'
            ? {
                width: 'calc(100% - 40px)',
                borderRadius: 14,
              }
            : {
                width: '100%',
                borderRadius: 14,
              }
        }
        extra={
          <Button
            onClick={goBack}
            style={{ borderRadius: 8, fontSize: 14, height: 34, padding: '4px 20px' }}
            type={'primary'}
          >
            返回
          </Button>
        }
      >
        <Row align="middle">
          <Col className={commitDetailStyle.Avatar}>
            <img
              src={constants.BACKEND_API_URL + userInfo?.avatar}
              alt="头像"
              width={52}
              height={52}
            />
          </Col>
          <Col span={6}>
            <div className={commitDetailStyle.infoList}>
              <div className={commitDetailStyle.infoRow}>
                <div>ID</div>
                <div>{userInfo?.user_id}</div>
              </div>
              <div className={commitDetailStyle.infoRow}>
                <div>昵称</div>
                <div>{userInfo?.name}</div>
              </div>
            </div>
          </Col>
          <Col span={6}>
            <div className={commitDetailStyle.infoList}>
              <div className={commitDetailStyle.infoRow}>
                <div>真实姓名</div>
                <div>{userInfo?.real_name}</div>
              </div>
              <div className={commitDetailStyle.infoRow}>
                <div>学号/工号</div>
                <div>{userInfo?.number}</div>
              </div>
            </div>
          </Col>
          <Col span={6}>
            <div className={commitDetailStyle.infoList}>
              <div className={commitDetailStyle.infoRow}>
                <div>性别</div>
                <div>{userInfo?.sex}</div>
              </div>
            </div>
          </Col>
        </Row>
      </Card>
      <div
      
        className={
          mode == 'oam'
            ? commitDetailStyle.contentWapper
            : mode == 'college-oam'
            ? commitDetailStyle.collegeContentWapper
            : commitDetailStyle.teacherContentWapper
        }
      >
        <div className={commitDetailStyle.contentInfo}>
          <div className={commitDetailStyle.ListItem}>
            <div className={commitDetailStyle.ListRow}>
              <div>提交ID：</div>
              <div>
                <span>{taskInfo?.id}</span>
                {/* <Tag color={'#00cc99'} style={{ marginLeft: 10 }}>
                  已完成
                </Tag> */}
              </div>
            </div>
            <div className={commitDetailStyle.ListRow}>
              <div>项目：</div>
              <div>{taskInfo?.project}</div>
            </div>
            <div className={commitDetailStyle.ListRow}>
              <div>任务编号：</div>
              <div>
                <span>{taskInfo?.task_number}</span>
              </div>
            </div>
          </div>
          <div className={commitDetailStyle.ListItem}>
            <div className={commitDetailStyle.ListRow}>
              <div>开始时间：</div>
              <div>
                <span>{taskInfo?.start_time}</span>
              </div>
            </div>
            <div className={commitDetailStyle.ListRow}>
              <div>结束时间：</div>
              <div>
                <span>{taskInfo?.end_time}</span>
              </div>
            </div>
            <div className={commitDetailStyle.ListRow}>
              <div>任务名称：</div>
              <div>
                {/* <Link to={'/'}>{taskInfo?.task_name}</Link> */}
                <span>{taskInfo?.task_name}</span>
              </div>
            </div>
          </div>
        </div>
        <div className={commitDetailStyle.taskDetail}>
          <div className={commitDetailStyle.taskDetailTitle}>任务详情:</div>
          <div
            className={
              mode == 'teacher'
                ? commitDetailStyle.teacherCodeContain
                : commitDetailStyle.codeContain
            }
          >
            <Collapse
              defaultActiveKey={['1']}
              ghost
              className={commitDetailStyle.submitBox}
            >
              <Panel header="提交代码" key="1">
                <div className={commitDetailStyle.codeBlock}>
                  <SyntaxHighlighter
                    language={codeLanguage}
                    style={oneLight}
                    showLineNumbers
                    wrapLongLines
                    customStyle={{margin: 0, borderRadius: '0 0 10px 10px', fontSize: 14}}
                  >
                    {taskInfo?.task_detail?.user_code || ''}
                  </SyntaxHighlighter>
                </div>
              </Panel>
            </Collapse>

            <Collapse
              defaultActiveKey={['1']}
              ghost
              className={commitDetailStyle.submitBox}
            >
              <Panel header="答案" key="1">
                <div className={commitDetailStyle.codeBlock}>
                  <SyntaxHighlighter
                    language={codeLanguage}
                    style={oneLight}
                    showLineNumbers
                    wrapLongLines
                    customStyle={{margin: 0, borderRadius: '0 0 10px 10px', fontSize: 14}}
                  >
                    {taskInfo?.task_detail?.answer_code || ''}
                  </SyntaxHighlighter>
                </div>
              </Panel>
            </Collapse>
          </div>
        </div>
        <div
          className={taskLearnStyles.outputResultWrapper}
          id="running-ouput-wrapper"
          style={{ width: '100%', padding: '24px 0', marginTop: 16 }}
        >
          <Tabs hidden={runningStatus == 1 || runningStatus == 4} type="card">
            <TabPane
              tab="运行结果"
              key="outputs"
              style={{
                overflow: 'auto',
                //maxHeight: `calc(100vh - ${verticalPane1Height + 120}px)`,
              }}
            >
              {outputs && !specialTreatment.current && (
                <ReactMarkdown
                  className={taskLearnStyles.outputRenderMarkdown}
                  remarkPlugins={[gfm, remarkMath]}
                  rehypePlugins={[rehypeHighlight, rehypeKatex, rehypeRaw]}
                >
                   {
                          outputs.replaceAll('\n', '\n\n')
                          // outputs
                          //
                        }
                </ReactMarkdown>
              )}

              {outputs && specialTreatment.current && (
                <div
                  className={taskLearnStyles.tbContainer}
                  style={{
                    color: '#374151',
                    marginLeft: 20,
                    marginRight: 20,
                    marginBottom: 10,
                    paddingTop: 0,
                    borderRadius: 5,
                  }}
                  dangerouslySetInnerHTML={{ __html: outputs }}
                ></div>
              )}

              <div>
                {' '}
                {!isAnimation &&
                  submitImages?.map((iamgeBase64, ind) => {
                    return (
                      <div
                        style={{
                          backgroundColor: '#fff',
                          margin: 10,
                          textAlign: 'center',
                        }}
                        key={String(ind)}
                      >
                        <img
                          style={{ backgroundColor: '#fff' }}
                          src={'data:image/jpg;base64,' + iamgeBase64}
                        ></img>
                      </div>
                    )
                  })}
                {isAnimation && (
                  <img
                    id="animation_img"
                    src={
                      'data:image/jpg;base64,' + submitImages && submitImages[0]
                    }
                    alt=""
                  />
                )}
              </div>

              <div
                id="user-image"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  overflow: 'auto',
                  backgroundColor: '#fff',
                }}
                dangerouslySetInnerHTML={{
                  __html: userImage?.replaceAll('\n', ''),
                }}
              />
            </TabPane>

            <TabPane
              tab="变量信息"
              key="variables"
              style={{
                overflow: 'auto',
                maxHeight: `calc(100vh - ${verticalPane1Height + 120}px)`,
              }}
            >
              <div className={taskLearnStyles.variableTableWrapper}>
                <ConfigProvider locale={zhCN}>
                  <Table
                    dataSource={variables}
                    columns={variableColumns}
                    rowKey={(record) => record.var}
                    pagination={false}
                  />
                </ConfigProvider>
              </div>
            </TabPane>
          </Tabs>
        </div>
      </div>
    </div>
  )
}

export default CommitDetail
